export class InvalidAddressResultError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'InvalidAddressResultError';
  }
}
